if (!window.customElements.get('product-specs-table')) {
  class ProductSpecsTable extends HTMLElement {
    constructor () {
      super();
      this.specsData = this.getAttribute('data-specs') ? JSON.parse(this.getAttribute('data-specs'))?.specs : null;
    }

    connectedCallback() {
      if (!this.specsData) return;
      this.buildTable();
    }

    buildTable() {
      const matrixType = this.specsData[0].MatrixType;
      const matrixValues = [];
      const matrixSpecs = [];

      this.specsData.map((spec) => {
        if(matrixValues.indexOf(spec.MatrixValue) >= 0) return;
        matrixValues.push(spec.MatrixValue);
      });

      this.specsData.map((spec) => {
        if(matrixSpecs.indexOf(spec.SpecName) >= 0) return;
        matrixSpecs.push(spec.SpecName);
      });

      this.innerHTML = `
        <table>
          <caption class="sr-only">
            Product specifications
          </caption>
          <thead>
            <tr>
              <th class="whitespace-nowrap bg-white sticky left-0 sm:relative sm:left-unset" scope="col">${matrixType}</th>
              ${matrixSpecs.map((matrixSpec) => {
                return `
                  <th class="whitespace-nowrap">
                    ${matrixSpec}
                  </th>
                `
              }).join('')}
            </tr>
          </thead>
          <tbody>
              ${matrixValues.map((matrixValue) => {
                return `
                  <tr class="odd:bg-light-gray-1 even:bg-white">
                    <td class="text-sm py-[13px] px-4 whitespace-nowrap bg-inherit sticky left-0 sm:relative sm:left-unset" scope="row">
                      ${matrixValue}
                    </td>

                    ${matrixSpecs.map((matrixSpec) => {
                      const matchingSpec = this.specsData.find((spec) => spec.MatrixValue == matrixValue && spec.SpecName == matrixSpec);
                      return `
                        <td class="text-sm p-3 whitespace-nowrap">
                          ${matchingSpec?.SpecValue || ''}
                        </td>
                      `
                    }).join('')}
                  </tr>
                `
              }).join('')}
          </tbody>
        </table>
      `;
    }
  }

  window.customElements.define('product-specs-table', ProductSpecsTable);
}
